module.exports = __webpack_public_path__ + "static/img/text.bda626b.png";